<template>
  <v-row>
    <v-col cols="12" class="pb-0">
      <v-alert dense dark color="primary">
        <template v-slot:prepend>
          <v-icon size="28" color="white" class="mr-3">mdi-information-outline</v-icon>
        </template>
        Parked domains make your website available from another domain name. For example, you can make
        www.example.net and www.example.org show content from www.example.com.
      </v-alert>
    </v-col>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          Add New Parked Domain
        </gg-card-header>
        <gg-card-text>
          <add-alias-form @domain-created="reloadTable"></add-alias-form>
        </gg-card-text>
      </gg-card>
    </v-col>
    <v-col cols="12">
      <aliases-table
        @table-reloaded="tableReloaded"
        :table-should-be-reloaded="tableShouldBeReloaded"
      />
    </v-col>
  </v-row>
</template>

<script>
import AddAliasForm from '@/components/Services/Hosting/Shared/Domains/Aliases/AddAliasForm'
import AliasesTable from '@/components/Services/Hosting/Shared/Domains/Aliases/AliasesTable'

export default {
  name: 'AliasesView',
  components: {
    AddAliasForm,
    AliasesTable,
  },
  data () {
    return {
      tableShouldBeReloaded: false,
    }
  },
  methods: {
    reloadTable () {
      this.tableShouldBeReloaded = true
    },
    tableReloaded () {
      this.tableShouldBeReloaded = false
    },
  },
}
</script>
